import * as React from "react";
import { connect } from "react-redux";
import * as moment from "moment";
import { cloneDeep } from "lodash";
import { AppShape, HurdleShape, ContactShape } from "@eave/shared/types/api";
import { Save16 } from "@carbon/icons-react";
import { Button } from "carbon-components-react";

import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { loadApp } from "../actions";
import APIClient from "../../APIClient";
import Contact from "../shared/Contact";

import { Column, TRUSTable } from "../../shared/TRUSTable";
import { Input } from "../../shared/Input";

require(`../../../assets/stylesheets/components/underwriter_dashboard/hurdle_editors/\
contact_info.scss`);
const styles = require("./styles.module.scss");

interface ContactInfoProps {
  app: AppShape;
  hurdle: HurdleShape;
  dispatch: Function;
  onHide: Function;
}

interface ContactRow {
  label: string;
  name: string;
  readonly?: boolean;
}

const ContactTableInput =
  ({ tabIndex = null, role, roleEnum, contactData, updateFn, readonlyFields = [] }) =>
  (row: ContactRow) =>
    (
      <Input
        tabIndex={tabIndex}
        acceptedInput="text"
        onChange={({ target: { value } }) => {
          updateFn(roleEnum, role, { [row.name]: value });
        }}
        value={(contactData && contactData[row.name]) || ""}
        readOnly={readonlyFields.includes(row.name) || row.readonly || false}
      />
    );

class ContactInfoEditor extends React.Component<ContactInfoProps, any> {
  constructor(props) {
    super(props);
    this.state = {};

    this.setStateForContactFields = this.setStateForContactFields.bind(this);
  }

  componentDidMount() {
    this.getContacts();
    this.getEaveTeamOptions();
  }

  getEaveTeamOptions() {
    const { app } = this.props;
    APIClient.get(`/uw/${app.id}/contacts/options`, response => {
      this.setState({ eave_team_options: response });
    });
  }

  getContacts() {
    const { app } = this.props;
    APIClient.get(`/${app.id}/contacts`, response => {
      this.setState(response);
    });
  }

  getFullName(names) {
    let name = "";
    for (const current of names) {
      if (current) {
        name += ` ${current}`;
      }
    }
    return name.trim();
  }

  age(dateOfBirth) {
    if (dateOfBirth) {
      return moment().diff(moment(dateOfBirth), "years");
    }
    return null;
  }

  // TODO Credit Reference No & Credit Order Date: don't believe these are stored
  // (see credit_reports table)
  // TODO Gender, Preferred Contact Method, array of Phones (with types) -- require backend work.
  renderBorrowers() {
    const { app } = this.props;
    const { borrowers } = app;

    return (
      <div>
        <div className="hurdles-editor__group">
          <h4 className="hurdles-editor__group-name">BORROWERS</h4>
          <table className="table hurdles-editor__table">
            <thead>
              <tr>
                <th className="col-lg-2" />
                {Object.keys(borrowers).map((borrowerEntity, i) => {
                  return <th key={borrowerEntity} className="col-lg-2">{`Borrower${i + 1}`}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Name</td>
                {Object.keys(borrowers).map(borrowerEntity => {
                  const borrower = borrowers[borrowerEntity];
                  return (
                    <td key={`name_${borrowerEntity}`}>
                      {this.getFullName([
                        borrower.first_name,
                        borrower.middle_name,
                        borrower.last_name,
                        borrower.suffix,
                      ])}
                    </td>
                  );
                })}
              </tr>
              <tr>
                <td>Social Security No</td>
                {Object.keys(borrowers).map(borrowerEntity => {
                  const borrower = borrowers[borrowerEntity];
                  return <td key={`ssn_${borrowerEntity}`}>{borrower.ssn}</td>;
                })}
              </tr>
              <tr>
                <td>Age</td>
                {Object.keys(borrowers).map(borrowerEntity => {
                  const borrower = borrowers[borrowerEntity];
                  return <td key={`age_${borrowerEntity}`}>{borrower.dob}</td>;
                })}
              </tr>
              <tr>
                <td>Marital Status</td>
                {Object.keys(borrowers).map(borrowerEntity => {
                  const borrower = borrowers[borrowerEntity];
                  return (
                    <td key={`marital_status_${borrowerEntity}`}>{borrower.relationship_status}</td>
                  );
                })}
              </tr>
              <tr>
                <td>Phone number</td>
                {Object.keys(borrowers).map(borrowerEntity => {
                  const borrower = borrowers[borrowerEntity];
                  return <td key={`phone_${borrowerEntity}`}>{borrower.phone}</td>;
                })}
              </tr>
              <tr>
                <td>Email</td>
                {Object.keys(borrowers).map(borrowerEntity => {
                  const borrower = borrowers[borrowerEntity];
                  return <td key={`email_${borrowerEntity}`}>{borrower.email}</td>;
                })}
              </tr>

              <tr>
                <td>Present address</td>
                {Object.keys(borrowers).map(borrowerEntity => {
                  const borrower = borrowers[borrowerEntity];
                  return (
                    <td key={`current_address_line1_${borrowerEntity}`}>
                      {borrower.current_address_line1}
                    </td>
                  );
                })}
              </tr>

              <tr>
                <td />
                {Object.keys(borrowers).map(borrowerEntity => {
                  const borrower = borrowers[borrowerEntity];
                  return (
                    <td key={`current_address_line2_${borrowerEntity}`}>
                      {borrower.current_address_line2}
                    </td>
                  );
                })}
              </tr>

              <tr>
                <td />
                {Object.keys(borrowers).map(borrowerEntity => {
                  const borrower = borrowers[borrowerEntity];
                  return (
                    <td key={`current_address_line3_${borrowerEntity}`}>
                      <span>{`${borrower.current_city}, ${borrower.current_state} ${borrower.current_postal_code}`}</span>
                    </td>
                  );
                })}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderEaveTeam() {
    const { contacts } = this.state;
    const { eave_team_options } = this.state;

    const loanOfficerOptions = eave_team_options && eave_team_options.loan_officers;
    const loanUnderwriterOptions = eave_team_options && eave_team_options.underwriters;
    const loanManagerOptions = eave_team_options && eave_team_options.loan_managers;
    const postCloserOptions = eave_team_options && eave_team_options.post_closers;
    const closerFunderOptions = eave_team_options && eave_team_options.closer_funders;

    const loanOfficer = contacts.loan_officer;
    const loanUnderwriter = contacts.loan_underwriter;
    const loanManager = contacts.loan_manager;
    const postCloser = contacts.post_closer;
    const closerFunder = contacts.closer_funder;

    // array of objects, rather than just strings, as to specify the field is readonly
    // add readonly: true to the given object
    // (see the Contact.tsx component)
    const eaveTeamFields = [
      { name: "name" },
      { name: "address_line1" },
      { name: "phone" },
      { name: "email" },
      { name: "nmls_id" },
    ];

    return (
      <div>
        <div className="hurdles-editor__group">
          <h4 className="hurdles-editor__group-name">EAVE TEAM</h4>

          <table className="table hurdles-editor__table">
            <thead>
              <tr>
                <th className="col-lg-2" />
                <th className="col-lg-2">Loan Officer</th>
                <th className="col-lg-2">Loan Underwriter</th>
                <th className="col-lg-2">Loan Manager</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <ul className="field-title-group">
                    <li>Name</li>
                    <li>Office</li>
                    <li>Phone</li>
                    <li>Email</li>
                    <li>NMLS ID</li>
                  </ul>
                </td>
                <td>
                  <Contact
                    options={loanOfficerOptions}
                    setFields={this.setStateForContactFields}
                    selectableField="name"
                    data={loanOfficer}
                    fields={eaveTeamFields}
                    role="loan_officer"
                    contact_role_enum="LoanOfficer"
                    handleOnChange={this.handleOnChange.bind(this)}
                  />
                </td>
                <td>
                  <Contact
                    options={loanUnderwriterOptions}
                    setFields={this.setStateForContactFields}
                    selectableField="name"
                    data={loanUnderwriter}
                    fields={eaveTeamFields}
                    role="loan_underwriter"
                    contact_role_enum="LoanUnderwriter"
                    handleOnChange={this.handleOnChange.bind(this)}
                  />
                </td>
                <td>
                  <Contact
                    options={loanManagerOptions}
                    setFields={this.setStateForContactFields}
                    selectableField="name"
                    data={loanManager}
                    fields={eaveTeamFields}
                    role="loan_manager"
                    contact_role_enum="LoanManager"
                    handleOnChange={this.handleOnChange.bind(this)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <table className="table hurdles-editor__table">
            <thead>
              <tr>
                <th className="col-lg-2" />
                <th className="col-lg-2">Closer/Funder</th>
                <th className="col-lg-2">Post Closer</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <ul className="field-title-group">
                    <li>Name</li>
                    <li>Office</li>
                    <li>Phone</li>
                    <li>Email</li>
                    <li>NMLS ID</li>
                  </ul>
                </td>
                <td>
                  <Contact
                    options={closerFunderOptions}
                    setFields={this.setStateForContactFields}
                    selectableField="name"
                    data={closerFunder}
                    fields={eaveTeamFields}
                    role="closer_funder"
                    contact_role_enum="CloserFunder"
                    handleOnChange={this.handleOnChange.bind(this)}
                  />
                </td>
                <td>
                  <Contact
                    options={postCloserOptions}
                    setFields={this.setStateForContactFields}
                    selectableField="name"
                    data={postCloser}
                    fields={eaveTeamFields}
                    role="post_closer"
                    contact_role_enum="PostCloser"
                    handleOnChange={this.handleOnChange.bind(this)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderPurchaseContacts() {
    const { contacts } = this.state;
    const { app } = this.props;

    const buyersRealtor = contacts.buyer_real_estate_agent;
    const buyersRealtorCompany = contacts.buyer_real_estate_agent_company;
    const buyersAttorney = contacts.buyer_attorney;
    const buyersAttorneyCompany = contacts.buyer_attorney_company;

    const sellersRealtor = contacts.seller_real_estate_agent;
    const sellersRealtorCompany = contacts.seller_real_estate_agent_company;
    const sellersAttorney = contacts.seller_attorney;
    const sellersAttorneyCompany = contacts.seller_attorney_company;

    const { seller1, seller2 } = contacts;

    const contactFields = [
      { label: "Contact Name", name: "name" },
      { label: "Contact Phone", name: "phone" },
      { label: "Contact Email ", name: "email" },
      { label: "Contact NMLS ID", name: "nmls_id" },
      { label: "Contact State License", name: "state_license" },
    ];

    const contactCompanyFields = [
      { label: "Company Name", name: "name" },
      { label: "Company Phone", name: "phone" },
      { label: "Company Email", name: "email" },
      { label: "Company Fax", name: "fax" },
      { label: "Company NMLS ID", name: "nmls_id" },
      { label: "Company State License", name: "state_license" },
      { label: "Company Address Line 1", name: "address_line1" },
      { label: "Company Address Line 2", name: "address_line2" },
      { label: "Company City", name: "city" },
      { label: "Company State", name: "state" },
      { label: "Company Postal Code", name: "postal_code" },
    ];

    const sellerFields = [
      { label: "Name", name: "name" },
      { label: "Address Line 1", name: "address_line1" },
      { label: "Address Line 2", name: "address_line2" },
      { label: "City", name: "city" },
      { label: "State", name: "state" },
      { label: "Postal Code", name: "postal_code" },
    ];

    return (
      <div>
        <div className="hurdles-editor__group">
          <h4 className="hurdles-editor__group-name">PURCHASE CONTACTS</h4>
          <TRUSTable className="table hurdles-editor__table" data={contactFields}>
            <Column>{field => field.label}</Column>
            <Column header="Buyer's Realtor">
              {ContactTableInput({
                tabIndex: 1,
                roleEnum: "BuyerRealEstateAgent",
                role: "buyer_real_estate_agent",
                contactData: buyersRealtor,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
            <Column header="Buyer's Attorney">
              {ContactTableInput({
                tabIndex: 2,
                roleEnum: "BuyerAttorney",
                role: "buyer_attorney",
                contactData: buyersAttorney,
                updateFn: this.setStateForContactFields,
                readonlyFields: ["nmls_id", "state_license"],
              })}
            </Column>
            <Column header="Seller's Realtor">
              {ContactTableInput({
                tabIndex: 3,
                roleEnum: "SellerRealEstateAgent",
                role: "seller_real_estate_agent",
                contactData: sellersRealtor,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
            <Column header="Seller's Attorney">
              {ContactTableInput({
                tabIndex: 4,
                roleEnum: "SellerAttorney",
                role: "seller_attorney",
                contactData: sellersAttorney,
                updateFn: this.setStateForContactFields,
                readonlyFields: ["nmls_id", "state_license"],
              })}
            </Column>
          </TRUSTable>
          <TRUSTable className="table hurdles-editor__table" data={contactCompanyFields}>
            <Column>{field => field.label}</Column>
            <Column header="Buyer's Realtor Company">
              {ContactTableInput({
                tabIndex: 1,
                roleEnum: "BuyerRealEstateAgentCompany",
                role: "buyer_real_estate_agent_company",
                contactData: buyersRealtorCompany,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
            <Column header="Buyer's Attorney Company">
              {ContactTableInput({
                tabIndex: 2,
                roleEnum: "BuyerAttorneyCompany",
                role: "buyer_attorney_company",
                contactData: buyersAttorneyCompany,
                updateFn: this.setStateForContactFields,
                readonlyFields: ["nmls_id", "state_license"],
              })}
            </Column>
            <Column header="Seller's Realtor Company">
              {ContactTableInput({
                tabIndex: 3,
                roleEnum: "SellerRealEstateAgentCompany",
                role: "seller_real_estate_agent_company",
                contactData: sellersRealtorCompany,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
            <Column header="Seller's Attorney Company">
              {ContactTableInput({
                tabIndex: 4,
                roleEnum: "SellerAttorneyCompany",
                role: "seller_attorney_company",
                contactData: sellersAttorneyCompany,
                updateFn: this.setStateForContactFields,
                readonlyFields: ["nmls_id", "state_license"],
              })}
            </Column>
          </TRUSTable>
        </div>

        <div className="hurdles-editor__group">
          <TRUSTable className="table hurdles-editor__table" data={sellerFields}>
            <Column>{field => field.label}</Column>
            <Column header="Seller 1">
              {ContactTableInput({
                tabIndex: 4,
                roleEnum: "Seller1",
                role: "seller1",
                contactData: seller1,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
            <Column header="Seller 2">
              {ContactTableInput({
                tabIndex: 5,
                roleEnum: "Seller2",
                role: "seller2",
                contactData: seller2,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
          </TRUSTable>
        </div>
        <div className="hurdles-editor__group">
          <table className="table hurdles-editor__table">
            <thead />
            <tbody>
              <tr>
                <td>Property Address</td>
                <td>
                  {app.computed_properties.purchased_property_address &&
                    app.computed_properties.purchased_property_address.line1}
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  {app.computed_properties.purchased_property_address &&
                    app.computed_properties.purchased_property_address.line2}
                </td>
              </tr>
              <tr>
                <td />
                <td>
                  <span>
                    {app.computed_properties.purchased_property_address &&
                      app.computed_properties.purchased_property_address.city}
                  </span>
                  <span>
                    {app.computed_properties.purchased_property_address &&
                      app.computed_properties.purchased_property_address.state}
                  </span>
                  <span>
                    {app.computed_properties.purchased_property_address &&
                      app.computed_properties.purchased_property_address.postal_code}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderPropertyContacts() {
    const { contacts } = this.state;

    const { appraiser } = contacts;
    const appraiserCompany = contacts.appraiser_company;

    const titleAgent = contacts.title_agent;
    const titleCompany = contacts.title_company;

    const settlementAgent = contacts.settlement_agent;
    const settlementAgentCompany = contacts.settlement_agent_company;

    const hazardInsuranceAgent = contacts.hazard_insurance_agent;
    const hazardInsuranceCompany = contacts.hazard_insurance_company;

    const floodInsuranceAgent = contacts.flood_insurance_agent;
    const floodInsuranceCompany = contacts.flood_insurance_company;

    const contactFields = [
      { label: "Contact Name", name: "name" },
      { label: "Contact Phone", name: "phone" },
      { label: "Contact Email", name: "email" },
      { label: "Contact State License", name: "state_license" },
    ];

    const contactCompanyFields = [
      { label: "Company Name", name: "name" },
      { label: "Company Phone", name: "phone" },
      { label: "Company Email", name: "email" },
      { label: "Company Fax", name: "fax" },
      { label: "Company State License", name: "state_license" },
      { label: "Company Address Line 1", name: "address_line1" },
      { label: "Company address Line 2", name: "address_line2" },
      { label: "Company City", name: "city" },
      { label: "Company State", name: "state" },
      { label: "Company Postal Code", name: "postal_code" },
    ];

    return (
      <div>
        <div className="hurdles-editor__group">
          <h4 className="hurdles-editor__group-name">PURCHASE CONTACTS</h4>
          <TRUSTable className="table hurdles-editor__table" data={contactFields}>
            <Column>{field => field.label}</Column>
            <Column header="Appraiser">
              {ContactTableInput({
                tabIndex: 6,
                role: "appraiser",
                roleEnum: "Appraiser",
                contactData: appraiser,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
            <Column header="Title Agent">
              {ContactTableInput({
                tabIndex: 7,
                role: "title_agent",
                roleEnum: "TitleAgent",
                contactData: titleAgent,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
            <Column header="Settlement Agent">
              {ContactTableInput({
                tabIndex: 8,
                role: "settlement_agent",
                roleEnum: "SettlementAgent",
                contactData: settlementAgent,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
          </TRUSTable>
          <TRUSTable className="table hurdles-editor__table" data={contactCompanyFields}>
            <Column>{field => field.label}</Column>
            <Column header="Appraiser Company">
              {ContactTableInput({
                tabIndex: 6,
                role: "appraiser_company",
                roleEnum: "AppraiserCompany",
                contactData: appraiserCompany,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
            <Column header="Title Company">
              {ContactTableInput({
                tabIndex: 7,
                role: "title_company",
                roleEnum: "TitleCompany",
                contactData: titleCompany,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
            <Column header="Settlement Agent Company">
              {ContactTableInput({
                tabIndex: 8,
                role: "settlement_agent_company",
                roleEnum: "SettlementAgentCompany",
                contactData: settlementAgentCompany,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
          </TRUSTable>
        </div>
        <div className="hurdles-editor__group">
          <TRUSTable className="table hurdles-editor__table" data={contactFields}>
            <Column>{field => field.label}</Column>
            <Column header="Hazard Insurance Agent">
              {ContactTableInput({
                tabIndex: 9,
                contactData: hazardInsuranceAgent,
                role: "hazard_insurance_agent",
                roleEnum: "HazardInsuranceAgent",
                updateFn: this.setStateForContactFields,
              })}
            </Column>
            <Column header="Flood Insurance Agent">
              {ContactTableInput({
                tabIndex: 10,
                role: "flood_insurance_agent",
                roleEnum: "FloodInsuranceAgent",
                contactData: floodInsuranceAgent,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
          </TRUSTable>
          <TRUSTable className="table hurdles-editor__table" data={contactCompanyFields}>
            <Column>{field => field.label}</Column>
            <Column header="Hazard Insurance Company">
              {ContactTableInput({
                tabIndex: 9,
                contactData: hazardInsuranceCompany,
                role: "hazard_insurance_company",
                roleEnum: "HazardInsuranceCompany",
                updateFn: this.setStateForContactFields,
              })}
            </Column>
            <Column header="Flood Insurance Company">
              {ContactTableInput({
                tabIndex: 10,
                role: "flood_insurance_company",
                roleEnum: "FloodInsuranceCompany",
                contactData: floodInsuranceCompany,
                updateFn: this.setStateForContactFields,
              })}
            </Column>
          </TRUSTable>
        </div>
      </div>
    );
  }

  setStateForContactFields(contact_role_enum, role, values) {
    const contacts = cloneDeep(this.state.contacts);

    // in either case, need a reset
    if (!contacts[role] || !values) {
      contacts[role] = { role: contact_role_enum };
    }

    values &&
      Object.keys(values).forEach(k => {
        contacts[role][k] = values[k];
      });

    this.setState({ contacts });
  }

  handleOnChange(contact_role_enum, e) {
    const [role, field] = e.target.name.split("-");

    // e === null when the operator clicks the "x" to deselect the current option
    const value = e === null ? "" : e.target.value;
    this.setStateForContactFields(contact_role_enum, role, { [field]: value });
  }

  onSave() {
    // Upsert each contact
    const { dispatch, app } = this.props;
    const { contacts } = this.state;

    const editableContacts = Object.keys(contacts)
      .filter(key => key !== "suggested_settlement_agents")
      .map(role => contacts[role]);

    const promises = editableContacts.filter(Boolean).map((contact: ContactShape) => {
      const updatedContact = {
        ...contact,
        source: "ContactInfoHurdle",
        loan_application_id: app.id,
      };
      if (["AppraiserCompany", "Appraiser"].includes(contact.role)) {
        updatedContact.source = "AppraisalResponseMISMO";
      }
      return APIClient.post(`/contacts`, updatedContact);
    });

    Promise.all(promises).then(() => loadApp(dispatch, app.id));
  }

  render() {
    const { app, hurdle, onHide } = this.props;
    const { contacts } = this.state;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        {this.renderBorrowers()}
        {contacts && this.renderEaveTeam()}
        {contacts && this.renderPurchaseContacts()}
        {contacts && this.renderPropertyContacts()}
        <footer className={styles.footer}>
          <Button kind="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button onClick={this.onSave.bind(this)} renderIcon={Save16}>
            Save changes
          </Button>
        </footer>
      </HurdleView>
    );
  }
}

export default connect()(ContactInfoEditor);
